import React, { useState, useEffect } from "react"
import { makeStyles } from "@mui/styles"
import { Box, Stack } from "@mui/material"

const useStyles = makeStyles({
  root: {
    borderTop: "1px solid #E6E6E6",
    background: "#FFF",
    display: "flex",
    padding: "24px",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "10px",
    maxHeight: "fit-content",
    position: "fixed",
    left: 0,
    width: "100vw",
    zIndex: 1000
  }
})

const ActionFooter = ({ rightAction, leftAction, justifyBetween = false }) => {

  const classes = useStyles()
  const [bottomPosition, setBottomPosition] = useState(0)

  useEffect(() => {
    const handleResize = () => {
      if (window.visualViewport) {
        // Get the visual viewport height and page offset
        const viewportHeight = window.visualViewport.height
        const viewportOffsetTop = window.visualViewport.offsetTop
        const windowHeight = window.innerHeight

        // Calculate how much the keyboard is covering
        const keyboardHeight = windowHeight - (viewportHeight + viewportOffsetTop)

        // Only adjust if keyboard is actually visible (positive height)
        setBottomPosition(Math.max(0, keyboardHeight))
      }
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleResize)
      window.visualViewport.addEventListener("scroll", handleResize)
      handleResize()
    }

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handleResize)
        window.visualViewport.removeEventListener("scroll", handleResize)
      }
    }
  }, [])

  return (
    <Box className={classes.root} sx={{ bottom: `${bottomPosition}px` }}>
      <Stack direction="row" spacing={2} width={"100%"} justifyContent={justifyBetween ? "space-between" : "flex-end"}>
        {leftAction}
        {rightAction}
      </Stack>
    </Box>
  )

}

export default ActionFooter
